<template>
  <sidebar>
    <div class="col-md-12 p-5">
      <div class="col-md-12">
        <h3 class="text-center">{{animal.id ? "Edição do animal: " + animal.name : "Cadastro de Animais"}}</h3>
        <v-divider class="mb-7"></v-divider>
        <v-text-field
          label="Nome"
          outlined
          v-model="animalEdit.name"
        ></v-text-field>
        <date-picker
          label="Data de Nascimento"
          :binding.sync="animalEdit.born_at"
          :readOnly="false"
        ></date-picker>
        <v-text-field
          label="Botton"
          outlined
          v-model="animalEdit.code"
        ></v-text-field>
        <v-select
          label="Gênero"
          outlined
          :items="genders"
          item-text="name"
          item-value="id"
          v-model="animalEdit.gender"
        ></v-select>
        <v-select
          label="Grau de Sangue"
          outlined
          :items="blood_degrees"
          item-text="name"
          item-value="name"
          v-model="animalEdit.degree_blood"
        ></v-select>
        <div class="d-flex align-items-center mb-6">
          <label class="pr-2 status-label">Ativo: </label>
          <v-switch
            inset
            v-model="animalEdit.active"
            color="var(--green)"
          ></v-switch>
        </div>
        <v-text-field
          outlined
          label="Registro"
          v-model="animalEdit.register"
        ></v-text-field>
        <v-text-field
          outlined
          label="RGN"
          v-model="animalEdit.rgn"
        ></v-text-field>
        <v-text-field
          outlined
          label="Apelido (opcional)"
          v-model="animalEdit.surname"
        ></v-text-field>
        <v-text-field
          outlined
          label="Código de Integração"
          v-model="animalEdit.code_integration"
        ></v-text-field>
        <v-select
          outlined
          :items="races"
          label="Raça"
          item-text="title"
          item-value="title"
          v-model="animalEdit.race"
        ></v-select>
      </div>
      <div class="col-md-12 d-flex">
        <v-btn 
          outlined class="btn-back mr-5"
          @click="$emit('close')"
        >
          Voltar
        </v-btn>
        <v-btn 
          @click="save"
          class="success"
        >
          Salvar
        </v-btn>
      </div>
    </div>
  </sidebar>
</template>

<script>
import Sidebar from "@/components/layout/Sidebar";
import DatePicker from '@/components/layout/DatePicker.vue';
import mixins from "@/mixins/helpers.js";
import { mapState } from "vuex";
export default {
  name:"SidebarEdit",
  mixins:[mixins],
  props:{
    animal:Object,
    blood_degrees:Array,
    races:Array
  },
  components: {
    Sidebar,
    DatePicker
  },
  data() {
    return {
      animalEdit:{}
    }
  },
  computed: {
    ...mapState("sidebar", ["active"]),
    genders() {
      return [
        {name:"Macho", id:"M"},
        {name:"Fêmea", id:"F"}
      ]
    }
  },
  methods: {
    save() {
      this.$emit("save", this.animalEdit);
      this.animalEdit = {};
    }
  },
  // N20: o formulário é (re)preenchido a cada abertura e limpo ao fechar — reabrir o mesmo
  // animal depois de cancelar não mostra mais os valores editados e não salvos
  watch: {
    active(val) {
      if(!val || !this.animal.id) {
        this.animalEdit = {};
        return;
      }
      this.animalEdit = {...this.animal};
      this.animalEdit.born_at = this.parseDateToBrazilianModel(this.animal.born_at);
      this.animalEdit.code_integration = this.animal.code_integration;
    }
  }
}
</script>

<style scoped>
.status-label {
  font-size: 1rem;
}
</style>